/* eslint-disable max-len */

import React from 'react';
import type { SVGProps } from 'react';

export interface TrophyProps extends SVGProps<SVGSVGElement> {
  color?: string;
}

export const Trophy: React.FC<TrophyProps> = ({ color = '#222A34', ...props }) => {
  return (
    <svg width={20} height={21} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_1266_26843)">
        <path
          d="M9.99992 12.8437C6.86384 12.8437 4.32154 10.3014 4.32154 7.16537V3.04329C4.32154 2.65162 4.32154 2.45579 4.37862 2.29898C4.47429 2.0361 4.68137 1.82902 4.94425 1.73334C5.10106 1.67627 5.29689 1.67627 5.68856 1.67627H14.3113C14.7029 1.67627 14.8988 1.67627 15.0556 1.73334C15.3185 1.82902 15.5255 2.0361 15.6212 2.29898C15.6783 2.45579 15.6783 2.65162 15.6783 3.04329V7.16537C15.6783 10.3014 13.136 12.8437 9.99992 12.8437ZM9.99992 12.8437V15.6829M15.6783 3.56906H16.9086C17.3496 3.56906 17.5701 3.56906 17.744 3.6411C17.9759 3.73716 18.1601 3.92139 18.2562 4.15329C18.3282 4.32721 18.3282 4.54769 18.3282 4.98866V5.46185C18.3282 6.34198 18.3282 6.78204 18.2315 7.14309C17.9689 8.12287 17.2036 8.88816 16.2239 9.1507C15.8628 9.24744 15.6783 9.24744 15.6783 9.24744M4.32154 3.56906H3.09123C2.65026 3.56906 2.42978 3.56906 2.25586 3.6411C2.02396 3.73716 1.83972 3.92139 1.74367 4.15329C1.67163 4.32721 1.67163 4.54769 1.67163 4.98866V5.46185C1.67163 6.34198 1.67163 6.78204 1.76837 7.14309C2.03091 8.12287 2.7962 8.88816 3.77598 9.1507C4.13703 9.24744 4.32154 9.24744 4.32154 9.24744M6.82423 18.7464H13.1756C13.4079 18.7464 13.5962 18.5581 13.5962 18.3258C13.5962 16.4674 12.0897 16.3944 11.3669 16.3944H8.6329C7.91016 16.3944 6.40361 16.4674 6.40361 18.3258C6.40361 18.5581 6.59193 18.7464 6.82423 18.7464Z"
          stroke={color}
          strokeWidth={1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.7453 5.01616C9.86269 4.82737 10.1375 4.82737 10.2548 5.01616L10.6911 5.71778C10.7324 5.7842 10.798 5.83187 10.8739 5.85062L11.676 6.04869C11.8918 6.10199 11.9767 6.36332 11.8335 6.53329L11.301 7.16498C11.2506 7.22479 11.2255 7.30192 11.2311 7.37993L11.2906 8.20396C11.3066 8.4257 11.0843 8.5872 10.8784 8.50346L10.1131 8.19225C10.0406 8.16279 9.95952 8.16279 9.88707 8.19225L9.12175 8.50346C8.91582 8.5872 8.69352 8.4257 8.70952 8.20396L8.76901 7.37993C8.77464 7.30192 8.74958 7.22479 8.69916 7.16498L8.16669 6.53329C8.02341 6.36331 8.10832 6.10199 8.32415 6.04869L9.12623 5.85062C9.20216 5.83187 9.26777 5.7842 9.30907 5.71778L9.7453 5.01616Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_1266_26843">
          <rect width={20} height={20} fill={color} transform="translate(0 0.211304)" />
        </clipPath>
      </defs>
    </svg>
  );
};
